<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h25"><a id="page_vi"><span class="txit">The Birdies Fly Away</span></a></h2><a id="page_vi">
<p class="image"><img alt="Images" height="342" src="images/f00vi-01.jpg" width="550"/></p>
<p class="center1">The birdies fly away, and they come back home.</p>
<p class="center1">The birdies fly away, and they come back home.</p>
<p class="center1">Fly away, fly away</p>
<p class="center1">All the birdies fly away,</p>
<p class="center1">The birdies fly away, and they come back home.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?63fd2b80